// Usage: https://feathericons.com/
import feather from "feather-icons";
import { DOM_LOADED } from './const'

document.addEventListener(DOM_LOADED, () => {
    feather.replace();
});

window.feather = feather;
